import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/branches/BranchesAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { BranchEditForm } from "./BranchEditForm";

export function BranchEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, branch } = useSelector(
    (state) => ({
      actionsLoading: state.branches.actionsLoading,
      isSuccess: state.branches.isSuccess,
      type: state.branches.type,
      branch: state.branches.branch
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getBranch(id));
    return () => dispatch(actions.cleanBranchesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Branş";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const saveBranch = (values) => {
    dispatch(actions.saveBranch(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/branslar`), 2500);
  };

  const btnRef = useRef();  
  const saveBranchClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <BranchEditForm
            branch={branch}
            btnRef={btnRef} 
            saveBranch={saveBranch}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveBranchClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}